import createSagaMiddleware from 'redux-saga'
import { all } from 'redux-saga/effects'

import Zoid from 'common/modules/zoid'
import Internal from 'common/modules/internal'

function* rootSaga({ dispatch, additionalSagas }) {
    yield all([
        Zoid.takes({
            dispatch,
        }),
        Internal.takes({
            dispatch,
        }),
        ...additionalSagas,
    ])
}

export const sagaMiddleware = createSagaMiddleware()

export const runRootSaga = (
    additionalSagas = [],
) => ({
    dispatch,
    getState,
}) => (
    sagaMiddleware.run(rootSaga, {
        dispatch,
        additionalSagas,
        getState,
    })
)
